import { render, staticRenderFns } from "./trainRosiPicture.vue?vue&type=template&id=66ad1111&scoped=true&"
import script from "./trainRosiPicture.vue?vue&type=script&lang=js&"
export * from "./trainRosiPicture.vue?vue&type=script&lang=js&"
import style0 from "./trainRosiPicture.vue?vue&type=style&index=0&id=66ad1111&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad1111",
  null
  
)

component.options.__file = "trainRosiPicture.vue"
export default component.exports